module.exports = __webpack_public_path__ + "static/media/routine.148e2acf.jpeg";